import { FaExchangeAlt } from "react-icons/fa";

const ReplaceIcon = () => <FaExchangeAlt size={24} />;

export default ReplaceIcon;